import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductTile/index.js";
const variants = import.meta.webpackContext("/components/ProductTile", { recursive: true, regExp: /\.\/__variants__\/plp\-promo\-label\/shown\/index\.js/ });
export default pointCut({ joinPoint, variants });